import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Survey\CreateSurveyController::__invoke
* @see app/Http/Controllers/Survey/CreateSurveyController.php
* @route '/api/survey'
*/
const CreateSurveyController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateSurveyController.url(options),
    method: 'post',
})

CreateSurveyController.definition = {
    methods: ["post"],
    url: '/api/survey',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Survey\CreateSurveyController::__invoke
* @see app/Http/Controllers/Survey/CreateSurveyController.php
* @route '/api/survey'
*/
CreateSurveyController.url = (options?: RouteQueryOptions) => {
    return CreateSurveyController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Survey\CreateSurveyController::__invoke
* @see app/Http/Controllers/Survey/CreateSurveyController.php
* @route '/api/survey'
*/
CreateSurveyController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateSurveyController.url(options),
    method: 'post',
})

export default CreateSurveyController